module.exports = __webpack_public_path__ + "img/fondazione-millesoli.17e07cb9.svg";